package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_03_28_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in Highridge, where demons and giants have invaded and driven the inhabitants fleeing to nearby Kostigan. A Chasme approaches the heroes, and they spring into action. Annette hastens Bigglesworth, who rushes forward slightly more carefully than he has in the past but is knocked unconscious by the horrible droning sound of the Chasme. Caper shoots Bigglesworth with her bow to wake him up, and later Caper heals Bigglesworth’s arrow wound. The heroes kill the Chasme, Giants, and Ettin. Dirk manipulates the weak mind of an Ettin named Frank, forcing him to dance uncontrollably.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("An ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("even bigger")
        }
        org.jetbrains.compose.web.dom.Text(" giant enters the fray — Storm Giant Andrew 26 feet tall! Tuesday, Dirk, and Annette fireball him, and Bigglesworth finishes him off. The giant falls on Bigglesworth when he dies.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes see something large and fiery approaching through the smoke.")
    }
}
